<div>
  <div class="flex flex-col gap-3">
    <h3 class="text-[20px] font-semibold">Mode de passation</h3>
    <div>
      <div class="mb-2.5">
        <button
          class="button_primary"
          type="button"
          (click)="openModePassationModal()"
        >
          Ajouter un mode de passation
        </button>
      </div>
      <div>
        <div>
          <app-ui-table
            [columns]="tableModePassation"
            [data]="modePassations"
            [actions]="rowActions"
          />
        </div>
      </div>
    </div>

    <ng-template #rowActions let-item="item" let-index="index">
      <div class="flex gap-2">
        <button class="button_secondary" (click)="onEditModePassation(item)">
          Modifier
        </button>
        <!--  -->
        <button class="button_danger" (click)="onDeleteModePassation(item)">
          Supprimer
        </button>
      </div>
    </ng-template>
  </div>
</div>

<!-- Votre modal -->
<app-modal
  [isVisible]="showAddModePassationModal"
  title="Ajouter un mode de passation"
  (closeEvent)="closeModePassationModal()"
>
  <form
    class="flex flex-col gap-5"
    [formGroup]="modePassationForm"
    (ngSubmit)="saveModePassation()"
  >
    <!-- <div>
            @if (lignebudgetaireForm.get('libelle')?.invalid && (lignebudgetaireForm.get('libelle')?.dirty || lignebudgetaireForm.get('libelle')?.touched)) {
                <span class="text-red-700 text-sm bg-red-100 p-2 rounded-md">
                    @if (lignebudgetaireForm.get('libelle')?.errors?.['required']) {
                        Entrez une ligne budgetaire
                    }
                </span>
            }
        </div> -->
    <app-input
      label="Mode de passation"
      type="text"
      formControlName="libelle"
    />
    <button
      type="submit"
      class="button_primary relative"
      [disabled]="isLoading"
    >
      <span [class.invisible]="isLoading">Enregistrer</span>
      @if (isLoading) {
        <div class="absolute inset-0 flex items-center justify-center">
          <app-loader></app-loader>
        </div>
      }
    </button>
  </form>
</app-modal>
